import React, { useEffect, useReducer, useState, useRef, useCallback } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useLocation, useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp'
import RoomIcon from '@material-ui/icons/Room'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'

import { get, post, put, del } from '../../config/fetch'
import AlertWrapper from '../common/alert'
import Geofencing from './index'
import Slider from '@material-ui/core/Slider'
import { circle } from '@turf/turf'
import Switch from '@material-ui/core/Switch'
import {
    TOKEN_CREATE_GEOFENCING,
    TOKEN_DELETE_GEOFENCING,
    TOKEN_GET_GEOFENCING_BY_ID,
    TOKEN_UPDATE_GEOFENCING,
} from '../../constants/constants'

const useStyles = makeStyles(theme => ({
    map: {
        position: 'relative',
        width: '98%',
        margin: '1em auto',
        padding: '1em',
        height: 'calc(100% - 2em)',
        overflowY: 'auto',
        [theme.breakpoints.down('md')]: {
            height: '300px',
        },
    },
    circularProgress: {
        width: '100%',
        overflowY: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '550px',
        [theme.breakpoints.down('md')]: {
            height: '300px',
        },
    },
}))

const defaultCenter = {
    lng: -99.160558,
    lat: 19.425869,
}

const marksSlider = [
    {
        value: 1,
        label: '1 m',
    },
    {
        value: 500,
        label: '500 m',
    },
]

const baseStationElement = () => {
    let el = document.createElement('div')
    el.className = 'marker-basestation'
    el.style.backgroundImage =
        'url(https://iconsplace.com/wp-content/uploads/_icons/ffffff/256/png/radio-tower-icon-18-256.png)'
    el.style.width = '40px'
    el.style.height = '40px'
    el.style.backgroundSize = '100%'
    el.style.opacity = '0.7'
    return el
}

function DialogDelete(props) {
    const { classes, handleCloseDialogDelete, state, handleDeleteBaseStation, visible } = props

    return (
        <Dialog
            open={visible}
            onClose={handleCloseDialogDelete}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Delete Base Station</DialogTitle>
            <DialogContent>
                <DialogContentText>Are you sure to delete this base station?</DialogContentText>
                {state.loading && (
                    <div className={classes.wrapperLoader}>
                        <CircularProgress />
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialogDelete} color="primary" disabled={state.loading}>
                    Cancel
                </Button>
                <Button
                    onClick={() => handleDeleteBaseStation(state.id)}
                    color="primary"
                    type="submit"
                    disabled={state.loading}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    )
}

function GeofencingDetail(props) {
    const { action } = props
    const { handleSubmit, control, setValue, getValues } = useForm()
    const classes = useStyles()
    const location = useLocation()
    const history = useHistory()
    const mapContainer = useRef()
    const [map, setMap] = useState(null)
    const [rangeKpi, setRangeKpi] = useState(400)
    // const [minutes, setMinutes] = useState(30)
    const [viewMinutes, setViewMinutes] = useState(false)
    const [typeGeofencing, setTypeGeofencing] = useState('')
    const [showConnections, setShowConnections] = useState(false)
    const [state, setState] = useReducer((s, a) => ({ ...s, ...a }), {
        error: null,
        loading: true,
        resolved: false,
        geofencing: {},
        message: null,
        typeMessage: null,
        visibleMessage: false,
    })
    const [stateDialogDelete, setStateDialogDelete] = useReducer((s, a) => ({ ...s, ...a }), {
        loading: false,
        visible: false,
        id: null,
    })
    const baseStationId = location.pathname.split('/')[2]

    useEffect(() => {
        let map = null

        if (action === 'create') {
            setState({
                ...state,
                loading: false,
                resolved: true,
            })
            map = initMap(defaultCenter.lat, defaultCenter.lng)

            //renderCircle(defaultCenter.lat, defaultCenter.lng, map)
            
            return () => map.remove()
        } else if (action === 'update') {
            const id = location.pathname.split('/')[2]
            fetchGeofencing(id).then(geo => {
                setState({
                    ...state,
                    loading: false,
                    resolved: true,
                    geofencing: geo,
                })
                map = initMap(geo.location.coordinates[1], geo.location.coordinates[0])
                setRangeKpi(Number(geo.radio))

                return () => map.remove()
            })
        }
        
    }, [])

    const onClickMap = (e, bs) => {
        if (!e.originalEvent.defaultPrevented) {
            setValue('latitude', e.lngLat.lat.toFixed(6))
            setValue('longitude', e.lngLat.lng.toFixed(6))
            
            renderCircle(e.lngLat, map)
        }
    }

    const callbackOnClick = useCallback(onClickMap, [
        map
    ])
    
    useEffect(() => {
        let refCallback = null
        if (map) {
            refCallback = e => callbackOnClick(e)
            map.on('click', refCallback)
            
            if (action === 'create') {
                renderCircle(defaultCenter, map)
            } else if (action === 'update') {
                const dflCen = {
                    lng: map.getCenter().lng.toFixed(4), lat: map.getCenter().lat.toFixed(4)
                }
                // [map.getCenter().lng.toFixed(4), map.getCenter().lat.toFixed(4)]
                renderCircle(dflCen, map)
            }
            
            return () => map.off('click', refCallback)
        }
    }, [map, callbackOnClick])
    

    const fetchGeofencing = async id => {
        try {
            const { data: geofencing } = await get(
                `/geofencing/${id}?code=${TOKEN_GET_GEOFENCING_BY_ID}`,
            )
            return geofencing
        } catch (e) {
            throw new Error(e)
        }
    }

    const initMap = (lat, lng) => {
        const map = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/dark-v9',
            center: [lng, lat],
            zoom: 15,
        })
        /*
        const el = baseStationElement()
        const marker = new mapboxgl.Marker({ element: el }).setLngLat([lng, lat]).addTo(map)

        map.on('move', () => {
            marker.setLngLat([map.getCenter().lng.toFixed(4), map.getCenter().lat.toFixed(4)])
        })
        */

        //let refCallback = e => callbackOnClick(e)
        //map.on('click', refCallback)
        
        map.on('moveend', () => {
            setValue('latitude', map.getCenter().lat.toFixed(6))
            setValue('longitude', map.getCenter().lng.toFixed(6))
        })

        map.on('load', () => {
            setMap(map)
            //renderCircle(lat, lng, map)

            /*
            const options = {
                steps: 64,
                units: 'kilometers',
                properties: { foo: 'bar' },
            }
            const newCircle = circle([lng, lat], rangeKpi, options)

            map.addSource('circleClicked', {
                type: 'geojson',
                data: newCircle,
            })

            map.addLayer({
                id: 'circleFill',
                type: 'fill',
                source: 'circleClicked',
                layout: {},
                paint: {
                    'fill-color': '#f08',
                    'fill-opacity': 0.1,
                },
            })
            
            map.addLayer({
                id: 'circleOutline',
                type: 'line',
                source: 'circleClicked',
                layout: {},
                paint: {
                    'line-color': '#f08',
                    'line-width': 1,
                },
            })
            */
        })

        return map
    }

    const renderCircle = (location, map) => {
        const { lng, lat } = location

        deleteCircle(map)

        const options = {
            steps: 64,
            units: 'kilometers',
            properties: { foo: 'bar' },
        }
        const newCircle = circle([lng, lat], (rangeKpi / 1000), options)
        
        map.addSource('circleClicked', {
            type: 'geojson',
            data: newCircle,
        })

        map.addLayer({
            id: 'circleFill',
            type: 'fill',
            source: 'circleClicked',
            layout: {},
            paint: {
                'fill-color': '#f08',
                'fill-opacity': 0.1,
            },
        })

        map.addLayer({
            id: 'circleOutline',
            type: 'line',
            source: 'circleClicked',
            layout: {},
            paint: {
                'line-color': '#f08',
                'line-width': 1,
            },
        })
    }

    const deleteCircle = (map) => {
        if (map.getSource('circleClicked')) {
            map.removeLayer('circleFill')
            map.removeLayer('circleOutline')
            map.removeSource('circleClicked')
        }
    }

    const handleForm = async data => {
        data.radio = rangeKpi;

        console.log('data: ', data)
        
        /*
        setState({
            ...state,
            loading: true,
            resolved: false,
        })

        if (action === 'create') {
            const responseCreate = await createGeofencing(data)
            if (responseCreate.success) {
                setState({
                    loading: false,
                    resolved: true,
                    visibleMessage: true,
                    typeMessage: 'success',
                    message: `Geofencing has been saved successfuly.`,
                })
            } else {
                setState({
                    loading: false,
                    resolved: true,
                    error: responseCreate.errors[0].msg,
                    visibleMessage: true,
                    typeMessage: 'error',
                    message: responseCreate.errors[0].msg,
                })
            }
        } else if (action === 'update') {
            const id = location.pathname.split('/')[2]
            const responseUpdate = await updateGeofencing(id, data)
            if (responseUpdate.success) {
                setState({
                    loading: false,
                    resolved: true,
                    visibleMessage: true,
                    typeMessage: 'success',
                    message: `Geofencing has been updated successfuly.`,
                })
            } else {
                setState({
                    loading: false,
                    resolved: true,
                    error: responseUpdate.errors[0].msg,
                    visibleMessage: true,
                    typeMessage: 'error',
                    message: responseUpdate.errors[0].msg,
                })
            }
        }
        */
    }

    const handleClickDelete = id => {
        setStateDialogDelete({
            ...stateDialogDelete,
            visible: true,
            id,
        })
    }

    const handleCloseDialogDelete = () => {
        setStateDialogDelete({
            ...stateDialogDelete,
            visible: false,
            id: null,
        })
    }

    const handleDeleteBaseStation = async id => {
        setStateDialogDelete({
            ...stateDialogDelete,
            loading: true,
        })
        deleteGeofencing(id)
            .then(response => {
                setStateDialogDelete({
                    ...stateDialogDelete,
                    loading: false,
                    visible: false,
                })
                setState({
                    ...state,
                    visibleMessage: true,
                    typeMessage: 'success',
                    message: `Geofencing has been deleted successfully.`,
                })
                setTimeout(() => {
                    history.goBack()
                }, 1500)
            })
            .catch(error => {
                setStateDialogDelete({
                    ...stateDialogDelete,
                    loading: false,
                })
            })
    }

    const createGeofencing = async data => {
        try {
            const dataResponse = await post(
                `/geofencing?code=${TOKEN_CREATE_GEOFENCING}`,
                data,
            )
            return dataResponse
        } catch (e) {
            throw new Error(e)
        }
    }

    const deleteGeofencing = async id => {
        try {
            const { data: baseStation } = await del(
                `/geofencing/${id}?code=${TOKEN_DELETE_GEOFENCING}`,
            )

            return baseStation
        } catch (e) {
            throw new Error(e)
        }
    }

    const updateGeofencing = async (id, data) => {
        try {
            const dataResponse = await put(
                `/geofencing/${id}?code=${TOKEN_UPDATE_GEOFENCING}`,
                data,
            )
            return dataResponse
        } catch (e) {
            throw new Error(e)
        }
    }

    const handleChangeSlider = (event, newValue) => {
        setRangeKpi(Number(newValue))
        const values = getValues(['latitude', 'longitude'])
        renderCircle({ lng: values[1], lat: values[0] }, map)
    }

    const handleChangeTypeGeofencing = (evt, item) => {
        setTypeGeofencing(evt.target.value)
        evt.target.value === 'STAY' ? setViewMinutes(true) : setViewMinutes(false) 
    }

    const handleSwitchConnections = e => {
        // showConnectionsRef.current = e.target.checked
        setShowConnections(e.target.checked)
    }

    const handleCloseMessageReport = () => {
        setState({
            ...state,
            visibleMessage: false,
        })
    }

    const flyToLocation = () => {
        const values = getValues(['latitude', 'longitude'])
        map.flyTo({
            center: [Number(values[1]), Number(values[0])],
        })
        renderCircle({ lng: values[1], lat: values[0] }, map)
    }

    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            flyToLocation()
        }
    }

    const cidOrEnb = value => {
        const values = getValues(['cid', 'eNB'])
        return Boolean(!!values[0] + !!values[1])
    }

    return (
        <Grid container spacing={0}>
            <Grid container direction="row" justify="center" alignItems="center">
                <Grid item xs={11} direction="column" style={{ borderBottom: '1px solid' }}>
                    <h2>Geofencing</h2>
                </Grid>
            </Grid>
            <Grid container direction="row" justify="center" alignItems="stretch">
                <Grid xs={11} lg={7} item>
                    <Paper
                        elevation={3}
                        style={{
                            width: '100%',
                            margin: '1em 0',
                            padding: '1em',
                            height: 'auto',
                            overflowY: 'auto',
                        }}
                    >
                        <Grid
                            xl={12}
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="center"
                            style={{ borderBottom: '1px solid #111' }}
                        >
                            <h3>Information</h3>
                        </Grid>
                        {state.resolved ? (
                            <form onSubmit={handleSubmit(handleForm)}>
                                <Grid
                                    container
                                    direction="row"
                                    style={{ padding: '1em 0' }}
                                    justify="space-between"
                                    alignItems="center"
                                    spacing={4}
                                >
                                    <Grid item xs={12} md={12} lg={12}>
                                        <Controller
                                            defaultValue={state.geofencing.name || ''}
                                            control={control}
                                            name="name"
                                            rules={{ required: true}}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    autoFocus
                                                    margin="dense"
                                                    label="Name Geofencing"
                                                    type="text"
                                                    fullWidth
                                                    required
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    style={{ padding: '1em 0' }}
                                    justify="space-between"
                                    alignItems="center"
                                    spacing={2}
                                >
                                    <Grid item xs={12} md={12} lg={12}>
                                        <Controller
                                            control={control}
                                            defaultValue={state.geofencing.title || ''}
                                            name="title"
                                            rules={{ required: true }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    margin="dense"
                                                    label="Notification Title"
                                                    type="text"
                                                    fullWidth
                                                    required
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    style={{ padding: '1em 0' }}
                                    justify="space-between"
                                    alignItems="center"
                                    spacing={2}
                                >
                                    <Grid item xs={12} md={12} lg={12}>
                                        <Controller
                                            control={control}
                                            defaultValue={state.geofencing.message || ''}
                                            name="message"
                                            rules={{ required: true }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    margin="dense"
                                                    label="Notification Message"
                                                    type="text"
                                                    fullWidth
                                                    required
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    style={{ padding: '1em 0' }}
                                    justify="space-between"
                                    alignItems="center"
                                    spacing={2}
                                >
                                    <Grid item xs={12} md={6} lg={6}>
                                        <InputLabel id="geofencing-type-label">
                                            Geofencing type *
                                        </InputLabel>
                                        <Controller
                                            control={control}
                                            defaultValue={state.geofencing.typeGeofencing || typeGeofencing}
                                            name="typeGeofencing"
                                            rules={{ required: false }}
                                            render={({ field, fieldState }) => (
                                                <Select
                                                    {...field}
                                                    labelId="geofencing-type-label"
                                                    id="geofencing-type"
                                                    onChange={handleChangeTypeGeofencing}
                                                    value={typeGeofencing}
                                                    fullWidth
                                                    required
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                >
                                                    <MenuItem value="">
                                                        <em>Select geofencing type</em>
                                                    </MenuItem>
                                                    <MenuItem value="IN">IN</MenuItem>
                                                    <MenuItem value="OUT">OUT</MenuItem>
                                                    <MenuItem value="STAY">STAY</MenuItem>
                                                </Select>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3} lg={3}>
                                        {
                                            viewMinutes ?
                                                <Controller
                                                    control={control}
                                                    defaultValue={state.geofencing.minutes || 30}
                                                    name="minutes"
                                                    rules={{ required: false }}
                                                    render={({ field, fieldState }) => (
                                                        <TextField
                                                            {...field}
                                                            margin="dense"
                                                            label="Minutes"
                                                            type="number"
                                                            fullWidth
                                                            inputRef={field.ref}
                                                            error={fieldState.invalid}
                                                        />
                                                    )}
                                                />
                                                : <></>
                                        }
                                    </Grid>
                                    <Grid item xs={12} md={3} lg={3}>
                                        {
                                            viewMinutes ?                     
                                                <InputLabel shrink id="repeat-label">
                                                    Repeat
                                                </InputLabel>
                                                : <></>
                                        }
                                        {
                                            viewMinutes ?
                                                <Controller
                                                    control={control}
                                                    defaultValue={false}
                                                    name="repeat"
                                                    rules={{ required: false }}
                                                    render={({ field, fieldState }) => (
                                                        <Switch 
                                                            
                                                            checked={showConnections}
                                                            onChange={handleSwitchConnections}
                                                            value="checkedRepeat"
                                                            color="primary"
                                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                                        />
                                                    )}
                                                />
                                                : <></>
                                        }
                                    </Grid>
                                </Grid>
                                
                                
                                
                                <Grid
                                    xl={12}
                                    container
                                    direction="row"
                                    justify="space-between"
                                    alignItems="center"
                                    style={{ borderBottom: '1px solid #111', marginTop: '2em' }}
                                >
                                    <h3>Location</h3>
                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    style={{ padding: '1em 0' }}
                                    justify="space-between"
                                    alignItems="flex-end"
                                    spacing={2}
                                >
                                    <Grid item xs={10} md={5} lg={3}>
                                        <Controller
                                            name="latitude"
                                            defaultValue={
                                                state.geofencing.location
                                                    ? Number(
                                                          state.geofencing.location.coordinates[1],
                                                      )
                                                    : defaultCenter.lat
                                            }
                                            control={control}
                                            rules={{ required: true }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    onKeyDown={handleKeyPress}
                                                    margin="dense"
                                                    label="Latitude"
                                                    type="number"
                                                    fullWidth
                                                    required
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={10} md={5} lg={3}>
                                        <Controller
                                            name="longitude"
                                            defaultValue={
                                                state.geofencing.location
                                                    ? Number(
                                                          state.geofencing.location.coordinates[0],
                                                      )
                                                    : defaultCenter.lng
                                            }
                                            control={control}
                                            rules={{ required: true }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    onKeyDown={handleKeyPress}
                                                    margin="dense"
                                                    label="Longitude"
                                                    type="number"
                                                    fullWidth
                                                    required
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={10} md={5} lg={3}>
                                        <InputLabel shrink id="radio-label">
                                            Radio
                                        </InputLabel>
{/*
                                        <Slider
                                            onChange={handleChangeSlider}
                                            value={rangeKpi}
                                            //getAriaValueText={valueSlider}
                                            aria-labelledby="radio-label"
                                            valueLabelDisplay="auto"
                                            step={1}
                                            min={1}
                                            max={10}
                                            marks={marksSlider}
                                            style={{ width: '90%', margin: '0 auto' }}
                                        />
*/}
                                        

                                        <Controller
                                            name="radio"
                                            defaultValue={state.geofencing.radio
                                                ? Number(
                                                    state.geofencing.radio,
                                                )
                                                : rangeKpi
                                            }
                                            control={control}
                                            //rules={{ required: true }}
                                            render={({ field, fieldState }) => (
                                                <Slider
                                                    onChange={handleChangeSlider}
                                                    value={rangeKpi}
                                                    //label="Radio"
                                                    //getAriaValueText={7}
                                                    //aria-labelledby="radio-label"
                                                    valueLabelDisplay="on"
                                                    //step={100}
                                                    min={1}
                                                    max={500}
                                                    marks={marksSlider}
                                                    //inputRef={field.ref}
                                                    style={{ width: '90%', margin: '0 auto' }}
                                                />
                                            )}
                                        />

                                    </Grid>                                    
                                    <Grid item xs={2} md={2} lg={3} align="start">
                                        <Button
                                            type="button"
                                            variant="contained"
                                            color="default"
                                            onClick={flyToLocation}
                                        >
                                            Show in map
                                            <RoomIcon />
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        ) : (
                            <div className={classes.circularProgress}>
                                <CircularProgress color="inherit" />
                            </div>
                        )}
                    </Paper>
                </Grid>
                <Grid xs={11} lg={4} item>
                    <Paper elevation={3} className={classes.map}>
                        <div className="map-container" ref={mapContainer} />
                    </Paper>
                </Grid>
            </Grid>
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                style={{ margin: '2em 0' }}
            >
                <Grid xs={11} container direction="row" justify="flex-end" alignItems="center">
                    <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit(handleForm)}
                    >
                        save
                    </Button>
                </Grid>
            </Grid>
            <AlertWrapper
                description={state.message}
                handleClose={handleCloseMessageReport}
                type={state.typeMessage}
                visible={state.visibleMessage}
            />
            <DialogDelete
                classes={classes}
                handleCloseDialogDelete={handleCloseDialogDelete}
                state={stateDialogDelete}
                handleDeleteBaseStation={handleDeleteBaseStation}
                visible={stateDialogDelete.visible}
            />
        </Grid>
    )
}

export default GeofencingDetail
